import { Content } from '../../types';

export const siemReapContent: Content = {
  title: 'סיאם ריפ (Siem Reap) - שער הכניסה למקדשי אנגקור',
  imageUrl: 'https://tinyurl.com/siem-reap-wide',
  introduction: `סיאם ריפ הינה אחת הערים התיירותיות המרכזיות בקמבודיה, ממוקמת בצפון-מערב המדינה, על גדות אגם טונלה סאפ (Tonle Sap Lake). העיר ידועה בעיקר בזכות קרבתה לאתר המורשת העולמית מקדשי אנגקור, קומפלקס של מקדשים עתיקים מתקופת האימפריה החמרית. רבים מהמבקרים בקמבודיה מגיעים אך ורק לסיאם ריפ כדי לחוות את פלאי אנגקור ואת האווירה הייחודית של העיר.`,
  sections: [
    {
      title: 'תיירות, מלונות ואווירה בעיר',
      content: [
        {
          subtitle: 'מלונות מומלצים:',
          text: `סיאם ריפ מציעה מגוון רחב של אפשרויות לינה, החל מהוסטלים ודירות אירוח ועד למלונות יוקרה עם בריכות מפנקות וספא. בין המלונות המומלצים בעיר:
• Shinta Mani Angkor - מלון יוקרתי עם עיצוב מודרני ושירות יוצא דופן
• Jaya House River Park - מלון בוטיק בסגנון טרופי על גדות הנהר
• The Aviary Hotel - מלון מעוצב בסגנון מודרני עם אווירה נעימה
• Lub d Siem Reap - אופציה מעולה לתרמילאים ולמטיילים בתקציב נמוך

מלבד מלונות, העיר שופעת במסעדות מגוונות המציעות אוכל קמבודי מסורתי לצד מטבחים מערביים. בתי קפה קטנים, מסעדות שף ושווקי אוכל הופכים את החוויה הקולינרית בסיאם ריפ לעשירה ומרתקת.`,
        },
      ],
      type: 'list',
    },
    {
      title: 'שווקים, חיי לילה ובילויים',
      content: [
        {
          subtitle: 'שווקים מומלצים:',
          text: `• השוק הישן (Old Market - Psar Chaa) - שוק צבעוני ומסורתי עם דוכנים של תבלינים, פירות, בדים ומזכרות.
• Angkor Night Market - שוק הלילה החדש, עם מבחר גדול של מוצרי אומנות ועבודות יד.
• Made in Cambodia Market - מקום מושלם לרכישת מזכרות אותנטיות מתוצרת מקומית.`,
        },
        {
          subtitle: 'Pub Street - הלב הפועם של חיי הלילה:',
          text: `רחוב Pub Street הוא היעד המרכזי לבילוי לילי בעיר. הרחוב מלא בברים, מסעדות ומועדונים עם מוזיקה חיה ואווירה תוססת. מומלצים במיוחד:
• Temple Bar - אחד הברים הפופולריים בעיר, עם הופעות ריקוד מסורתיות
• Miss Wong Cocktail Bar - בר בעיצוב סיני קלאסי עם קוקטיילים מצוינים
• Cheers Bar - מקום רגוע עם מחירים נוחים ואווירה ידידותית`,
        },
      ],
      type: 'list',
    },
    {
      title: 'מסלולי טיול מומלצים בסיאם ריפ והסביבה',
      content: [
        {
          subtitle: 'סיור במקדשי אנגקור (יום אחד או יותר):',
          text: `• אנגקור ואט Angkor Wat - המקדש המפורסם ביותר, סמל קמבודיה.
• באיון Bayon Temple - מקדש עם 54 מגדלים המעוטרים בפרצופים מחייכים.
• טא פרום Ta Prohm - "מקדש הטבע", שהתפרסם בסרט "טומב ריידר", עם עצים ענקיים הצומחים בין חורבותיו.

למי שרוצה להעמיק, מומלץ להקדיש יומיים-שלושה לחקר מקדשי אנגקור הרחוקים, כמו בנטאי סראי (Banteay Srei) ובנג מליאה (Beng Mealea).`,
        },
        {
          subtitle: 'שייט על אגם טונלה סאפ (חצי יום - יום מלא):',
          text: `אגם טונלה סאפ, הגדול באסיה, הוא ביתם של כפרים צפים מרתקים. מומלץ לבקר בכפרים:
• Kampong Phluk - כפר ציורי עם בתי כלונסאות ושווקי מים
• Chong Kneas - כפר תיירותי יותר, אך מספק הצצה לחיי הדייגים באזור`,
        },
        {
          subtitle: 'טיול יום לפנום קולן (Phnom Kulen):',
          text: `שמורת טבע יפהפייה ובה:
• מפל פנום קולן - מפל מרהיב עם אפשרות לרחצה
• פסל הבודהה השוכב - בודהה מגולף בסלע ענק על פסגת ההר
• נהר אלף הלינגות (Kbal Spean) - אתר ארכיאולוגי עם גילופי אבן בתוך נהר`,
        },
        {
          subtitle: 'חוויות תרבותיות ואטרקציות ייחודיות:',
          text: `• מופע קרקס קמבודי (Phare, The Cambodian Circus) - מופע מרהיב המשלב אקרובטיקה, תיאטרון ומוזיקה.
• The Landmine Museum - מוזיאון קטן ומרתק על שדות המוקשים של קמבודיה.
• Angkor Silk Farm - ביקור במשק חקלאי לגידול משי, כולל הדגמות של תהליך הייצור.`,
        },
      ],
      type: 'list',
    },
    {
      title: 'אגם טונלה סאפ',
      content: '',
      type: 'image',
      imageUrl: 'https://tinyurl.com/siem-reap-article-1',
    },
    {
      title: 'התניידות בעיר',
      content: `סיאם ריפ היא עיר נוחה לטיול, עם אפשרויות תחבורה מגוונות:
• טוקטוקים - הדרך הפופולרית ביותר, עם מחירים נוחים ביותר וגמישות רבה, מומלצת ביותר!
• מוניות ואפליקציות הזמנה - כמו Grab, מציעות חלופה נוחה יותר.
• אופניים וקטנועים - דרך מהנה לשוטט בעיר ובסביבתה.
• הליכה רגלית - אידיאלית בעיקר במרכז התיירותי של העיר.`,
      type: 'text',
    },
    {
      title: 'נגישות ודרכי הגעה',
      content: `סיאם ריפ נגישה בקלות, באמצעות שדה התעופה הבינלאומי סיאם ריפ-אנגקור, המחובר בטיסות לערים רבות באסיה. ניתן להגיע גם באוטובוסים מערים אחרות בקמבודיה כמו פנום פן ובאטאמבאנג, או ממדינות שכנות כמו תאילנד ווייטנאם.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `סיאם ריפ היא לא רק שער הכניסה לאנגקור, אלא גם עיר תוססת, עשירה בתרבות, היסטוריה וחוויות ייחודיות. בין אם אתם מתעניינים בארכיאולוגיה, בטבע, בחיי לילה או באוכל, העיר מציעה כייף והנאה לכל אחד. מומלץ להקדיש לה לפחות 3-4 ימים כדי ליהנות ממנה באמת.`,
      type: 'text',
    },
  ],
};
